import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, duration = 4000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const isSuccess = type === 'success';

  return (
    <div className="fixed top-6 right-6 z-[100] animate-slide-in">
      <div className={`flex items-center gap-3 rounded-lg border px-4 py-3 shadow-lg ${
        isSuccess
          ? 'border-green-200 bg-green-50 text-green-800'
          : 'border-red-200 bg-red-50 text-red-800'
      }`}>
        {isSuccess
          ? <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
          : <XCircle className="h-5 w-5 text-red-500 flex-shrink-0" />
        }
        <span className="text-sm font-medium">{message}</span>
        <button onClick={onClose} className="ml-2 flex-shrink-0 hover:opacity-70">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default Toast;
